export default "__VITE_ASSET__BzKfwQ_y__"